import React from "react";

const IconRocket = () => (
	<svg height="512" viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg">
		<path d="M23.508.003c-4.685-.084-10.028 2.365-13.41 6.164A12.69 12.69 0 001.402 9.87a.5.5 0 00.28.851l3.854.552-.476.533a.5.5 0 00.02.687l6.427 6.427a.499.499 0 00.687.019l.533-.476.552 3.854c.027.188.175.326.354.386a.46.46 0 00.143.022.565.565 0 00.387-.161c2.285-2.285 3.61-5.432 3.671-8.664 3.803-3.389 6.272-8.73 6.163-13.409a.502.502 0 00-.489-.488zM18.9 8.635c-.487.487-1.127.731-1.768.731s-1.281-.244-1.768-.731a2.505 2.505 0 010-3.536c.975-.975 2.561-.975 3.536 0s.975 2.562 0 3.536zM2.724 16.905c-1.07 1.07-2.539 5.904-2.703 6.451a.502.502 0 00.623.623c.547-.164 5.381-1.633 6.451-2.703a3.094 3.094 0 000-4.371 3.095 3.095 0 00-4.371 0z"/>
	</svg>
);

export default IconRocket;
